webpackJsonp([35783957827783],{

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/augusta-intro.470b.mp4";

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/augusta-intro.9918.webm";

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(7);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _stylesModule = __webpack_require__(194);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Card = function Card(_ref) {
	  var to = _ref.to,
	      text = _ref.text,
	      image = _ref.image;
	  return React.createElement(
	    _gatsbyLink2.default,
	    { key: to, to: to, className: _stylesModule2.default.card },
	    React.createElement(
	      'h3',
	      { className: _stylesModule2.default.link },
	      text
	    ),
	    React.createElement(_gatsbyImage2.default, {
	      outerWrapperClassName: _stylesModule2.default.cardImage,
	      className: _stylesModule2.default.cardImage,
	      sizes: image.sizes
	    })
	  );
	};
	
	exports.default = Card;
	module.exports = exports['default'];

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"card":"src-components-Card----styles-module---card---1vc51","cardImage":"src-components-Card----styles-module---cardImage---36KLo","link":"src-components-Card----styles-module---link---2rCAm"};

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = new Map([['restaurant', {
	  to: '/restaurant',
	  text: 'restaurant',
	  image: 'restaurantCardImage'
	}], ['docking', {
	  to: '/docking',
	  text: 'yachtDocking',
	  image: 'dockingCardImage'
	}], ['accommodation', {
	  to: '/accommodation',
	  text: 'accommodation',
	  image: 'accommodationCardImage'
	}], ['tours', {
	  to: '/tours',
	  text: 'adventureTours',
	  image: 'toursCardImage'
	}]]);
	module.exports = exports['default'];

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  landingSectionTitle: 'Family tradition in Lastovo',
	  landingSectionSubtitle: 'Our home tells the story of who we are and what we love and cherish the most',
	  bookNow: 'Book now',
	  restaurant: 'Restaurant',
	  yachtDocking: 'Yacht docking',
	  accommodation: 'Accommodation',
	  adventureTours: 'Adventure tours',
	  paragraphTitle: 'The best place to eat, sleep, dock, and have fun on Lastovo Island',
	  paragraphDescription: "A place of an authentic simplicity and traditional Mediterranean cuisine. The island of Lastovo is distinctly different from other tourist destinations. If you're looking for a quality bite to eat and unique experiences, tavern Augusta Insula is a perfect place to visit!",
	  readMore: 'Read more',
	  bookRestaurant: 'Restaurant Reservations',
	  bookVilla: 'Villa Booking',
	  bookDock: 'Docking Reservations',
	  testimonials: 'Testimonials'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.imagesQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Home = __webpack_require__(156);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _home = __webpack_require__(368);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _i18n = __webpack_require__(13);
	
	var _testimonials = __webpack_require__(151);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var logo = _ref.logo,
	      locale = _ref.locale,
	      data = _ref.data;
	  return _react2.default.createElement(_Home2.default, {
	    data: data,
	    logo: logo,
	    locale: locale,
	    i18n: (0, _i18n.i18n)(_home2.default)
	  });
	};
	
	exports.default = IndexPage;
	var imagesQuery = exports.imagesQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.homeImagesFragment = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(7);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Reviews = __webpack_require__(94);
	
	var _Reviews2 = _interopRequireDefault(_Reviews);
	
	var _Card = __webpack_require__(117);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _augustaIntro = __webpack_require__(231);
	
	var _augustaIntro2 = _interopRequireDefault(_augustaIntro);
	
	var _augustaIntro3 = __webpack_require__(232);
	
	var _augustaIntro4 = _interopRequireDefault(_augustaIntro3);
	
	var _pages = __webpack_require__(150);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _stylesModule = __webpack_require__(201);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeTemplate = function HomeTemplate(_ref) {
	  var logo = _ref.logo,
	      data = _ref.data,
	      locale = _ref.locale,
	      i18n = _ref.i18n;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.wrapper },
	    _react2.default.createElement(
	      'section',
	      { className: _stylesModule2.default.landingSection },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.landingVideo },
	        _react2.default.createElement(
	          'video',
	          {
	            autoPlay: true,
	            loop: true,
	            playsInline: true,
	            muted: true,
	            poster: data.landingImage.sizes.src,
	            style: {
	              width: '100%',
	              height: '100%',
	              backgroundSize: 'cover',
	              backgroundRepat: 'no-repeat',
	              objectFit: 'cover'
	            }
	          },
	          _react2.default.createElement('source', { src: _augustaIntro4.default, type: 'video/webm; codecs=vp9,vorbis' }),
	          _react2.default.createElement('source', { src: _augustaIntro2.default, type: 'video/mp4' })
	        )
	      ),
	      logo ? _react2.default.createElement(_gatsbyImage2.default, { className: _stylesModule2.default.logo, sizes: logo.sizes }) : null,
	      _react2.default.createElement(
	        'h1',
	        { className: _stylesModule2.default.headerTitle },
	        i18n('landingSectionTitle')
	      ),
	      _react2.default.createElement(
	        'h3',
	        { className: _stylesModule2.default.subtitle },
	        i18n('landingSectionSubtitle')
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { className: _stylesModule2.default.bookNowButton, anchor: 'contact-btns' },
	        i18n('bookNow')
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: _stylesModule2.default.cards },
	      Array.from(_pages2.default.values(), function (_ref2) {
	        var to = _ref2.to,
	            text = _ref2.text,
	            image = _ref2.image;
	        return _react2.default.createElement(_Card2.default, {
	          key: to,
	          to: '/' + locale + to,
	          text: i18n(text),
	          image: data[image]
	        });
	      })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: _stylesModule2.default.paragraph, id: 'contact-btns' },
	      _react2.default.createElement(
	        'h2',
	        { className: _stylesModule2.default.title },
	        i18n('paragraphTitle')
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _stylesModule2.default.description },
	        i18n('paragraphDescription')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.bookButtons },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + locale + _pages2.default.get('restaurant').to + '#contact-form' },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: _stylesModule2.default.readMoreButton },
	            i18n('bookRestaurant')
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + locale + _pages2.default.get('accommodation').to + '#contact-form' },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: _stylesModule2.default.readMoreButton },
	            i18n('bookVilla')
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + locale + _pages2.default.get('docking').to + '#contact-form' },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: _stylesModule2.default.readMoreButton },
	            i18n('bookDock')
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Reviews2.default, { title: i18n('testimonials'), image: data.testimonialsImage })
	  );
	};
	
	exports.default = HomeTemplate;
	var homeImagesFragment = exports.homeImagesFragment = '** extracted graphql fragment **';

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-templates-Home----styles-module---wrapper---1w-a5","landingSection":"src-templates-Home----styles-module---landingSection---2VvrP","landingVideo":"src-templates-Home----styles-module---landingVideo---35ITu","logo":"src-templates-Home----styles-module---logo---7catS","headerTitle":"src-templates-Home----styles-module---headerTitle---1rQ6j","subtitle":"src-templates-Home----styles-module---subtitle---1JeyF","cards":"src-templates-Home----styles-module---cards---nRkdQ","paragraph":"src-templates-Home----styles-module---paragraph---1Hm7M","title":"src-templates-Home----styles-module---title---oFFBR","bookNowButton":"src-templates-Home----styles-module---bookNowButton---1gyCL","readMoreButton":"src-templates-Home----styles-module---readMoreButton---rE-Nz","bookButtons":"src-templates-Home----styles-module---bookButtons---2J1Tr","description":"src-templates-Home----styles-module---description---Vjwxm","stars":"src-templates-Home----styles-module---stars---2TNcw","star":"src-templates-Home----styles-module---star---1oXa1"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-47eee5b940dc0b9c867b.js